import { NumerologyContainer } from "./style";

export const Numerology = ({ data }) => {
    return null
}